import React, { Component } from 'react'
import {
  CardNumberElement,
  CardCvcElement,
  CardExpiryElement,
  injectStripe
} from 'react-stripe-elements';
import TextField from 'material-ui/TextField'
import { FormattedMessage } from 'react-intl'
import IconButton from 'material-ui/IconButton'
import HelpIcon from 'material-ui/svg-icons/action/help'
import ReactTooltip from 'react-tooltip'
import images from '../../../config/images'
import { checkJapanese } from '../../../lib'
import './StripePaymentForm.css';
import CurrencyFormat from 'react-currency-format';

const createOptions = () => {
  return {
    style: {
      base: {
        fontSize: '16px',
        color: '#424770',
        height: '40px',
        fontFamily: 'Open Sans, sans-serif',
        letterSpacing: '0.025em',
        '::placeholder': {
          color: '#aab7c4',
        },
        marginBottom: '20px'
      },
      invalid: {
        color: '#c23d4b',
      },
    }
  }
};

class StripePaymentForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorMessage: '',
      brand: images['creditCards'],
      checked:true,
      cardNumberErr: '',
      cardExpiryErr: '',
      disableButton:true,
    }
    this.onChangeAction = this.onChangeAction.bind(this);
  }

  handleChangeToken = ({ error, brand }) => {
    if (error) {
      if(error.code === 'invalid_number')
        this.setState({ cardNumberErr: error.message});
      else
        this.setState({ cardExpiryErr: error.message});
      this.setState({errorMessage:  error.message})
    } else {
      this.setState({ errorMessage: '', cardExpiryErr:'', cardNumberErr:'', disableButton:false });
    }
    if (brand !== undefined && brand !== 'unknown') {
      this.setState({ brand: images[brand] });
    }
  };

  handleSubmit = (evt) => {
    evt.preventDefault();
    if (this.props.stripe && this.state.errorMessage === '' && this.props.domainNameErrors === '') {
      this.props.stripe.createToken().then(this.props.stripeTokenHandler);
    } else {
      console.log("Stripe.js hasn't loaded yet.");
    }
  }

  onChangeAction = e =>{
    this.setState({checked:e.target.checked})
  }

  render() {
    if (this.props.currentStep !== 1) {
      return null
    }
    return (
      <form onSubmit={this.handleSubmit} className="stripe-payment-form">
        <h2 className="text-center"><FormattedMessage id="CreateDomainLabel.applicationForm" /></h2>
        <p className="text-center"><FormattedMessage id="CreateDomainLabel.continueService" /></p>
        <div className="box-shadow form-box">
          <div className="box-header">
            <span className="required">※<FormattedMessage id="CreateDomainLabel.required" /></span> <FormattedMessage id="CreateDomainLabel.desiredPlan" />
          </div>
          <div className="box-body">
            <div className="input-row">
              <div>
                <label>
                  <FormattedMessage id="CreateDomainLabel.desiredAccounts" />
                </label>
              </div>
              <div className="space-right">
                <div className="width120">
                  <TextField
                    type="number"
                    value={this.props.accounts_allowed}
                    onChange={e => this.props.handleChange(e, 'accounts_allowed')}
                    fullWidth
                    required
                    max="50"
                    min="1"
                    step="1"
                    className="input-box"
                    errorText={this.props.accountsAllowedErr ? <FormattedMessage id='login.requiredField' /> : ''}
                  />
                </div>
                <span>ID</span>
              </div>
            </div>
            <div className="input-row">
              <div>
                <label>
                  <FormattedMessage id="CreateDomainLabel.desiredRooms" />
                </label>
              </div>
              <div className="space-right">
                <div className="width120">
                  <TextField
                    type="number"
                    value={this.props.rooms_allowed}
                    onChange={e => this.props.handleChange(e, 'rooms_allowed')}
                    fullWidth
                    required
                    min="1"
                    max="50"
                    step="1"
                    className="input-box"
                    errorText={this.props.roomsAllowedErr ? <FormattedMessage id='login.requiredField' /> : ''}
                  />
                </div>
                <span><FormattedMessage id="CreateDomainLabel.room" /></span>
              </div>
            </div>
            <div className="input-row">
              <div>
                <label>
                  <FormattedMessage id="CreateDomainLabel.domainCompany" />
                  <ReactTooltip
                    place='top'
                    multiline
                    effect='solid'
                    html />
                  <IconButton
                    style={{ width: 36, height: 36 }}
                    disableTouchRipple
                    iconStyle={{ fill: '#DADADA', width: 18, height: 18 }}>
                    <HelpIcon
                      data-tip={`
                        <div
                          class='pb2 custom-tooltip'>
                          ${(checkJapanese()) ? `
                            https://fv.lfv.jp/xxx/部屋名 のxxx部分に入れる3文字以上の小文字英数字を入力してください
                            ` : `
                            https://fv.lfv.jp/xxx/ Please enter at least 3 lowercase alphanumeric characters to be inserted in the xxx part of the room name
                          `}
                        </div>`}
                      hoverColor='#a8a6a6' />
                  </IconButton>
                </label>
              </div>
              <div>
                <TextField
                  value={this.props.domain_name}
                  onChange={e => this.props.handleDomainChange(e)}
                  onBlur={e => this.props.handleDomainChange(e)}
                  required
                  hintText="anet"
                  style={{ width: '224px' }}
                  className="domain-input-box"
                  errorText={this.props.domainNameErrors && this.props.domainNameErrors.props ? <FormattedMessage id={this.props.domainNameErrors.props.id} /> : this.props.domainNameErrors }
                />
              </div>
            </div>
            <div className="price-box">
              {this.props.campaign ?
                <p><FormattedMessage id="CreateDomainLabel.initialPrice" />: <span className="price-value strike-text"> <CurrencyFormat value={this.props.initial_price} displayType={'text'} thousandSeparator={true} prefix={'￥'} /> <FormattedMessage id="CreateDomainLabel.taxIncluded" /></span>
                  <span className="price-value">￥0</span>
                </p>
                :
                <p><FormattedMessage id="CreateDomainLabel.initialPrice" />: <span className="price-value"><CurrencyFormat value={this.props.initial_price} displayType={'text'} thousandSeparator={true} prefix={'￥'} /> <FormattedMessage id="CreateDomainLabel.taxIncluded" /></span></p>
              }
              <p><FormattedMessage id="CreateDomainLabel.monthlyCost" />: <span className="price-value"> <CurrencyFormat value={this.props.total_price} displayType={'text'} thousandSeparator={true} prefix={'￥'} /> <FormattedMessage id="CreateDomainLabel.taxIncluded" /></span></p>

              <p>※<FormattedMessage id="CreateDomainLabel.priceListDetails" /> <a href="https://www.freshvoice.net/lite/" target="_blank"><span className="price-text"><FormattedMessage id="CreateDomainLabel.here" /></span></a> <FormattedMessage id="CreateDomainLabel.referTo" /></p>
            </div>
          </div>
        </div>
        <div className="box-shadow form-box info-block">
          <div className="box-header">
            <span className="required">※<FormattedMessage id="CreateDomainLabel.required" /></span> <FormattedMessage id="CreateDomainLabel.ccInfo" />
          </div>
          <div className="box-body">
            { !this.state.cardExpiryErr && !this.state.cardNumberErr && (this.state.errorMessage || this.props.errorMessage) && <div className="error-msg" role="alert">
              {this.state.errorMessage}
              {this.props.errorMessage}
            </div>}
            <div className="ccImage">
              <img src={this.state.brand} height="50" />
            </div>
            <div className="input-row">
              <label>
                <FormattedMessage id="CreateDomainLabel.cardNumber" />
              </label>
              <div>
                <CardNumberElement
                  onChange={this.handleChangeToken}
                  {...createOptions()}
                />
              </div>
              {this.state.cardNumberErr &&  <div className="error" role="alert" style={{color:'#dc3545'}}>
                {this.state.cardNumberErr}
              </div>}
            </div>
            <div className="input-row">
              <label><FormattedMessage id="CreateDomainLabel.ccExpirationDate" /></label>
              <div className="input-row-col">
                <CardExpiryElement
                  onChange={this.handleChangeToken}
                  {...createOptions()}
                />
              </div>
              {this.state.cardExpiryErr &&  <div className="error" role="alert" style={{color:'#dc3545'}}>
                {this.state.cardExpiryErr}
              </div>}
            </div>
            <div className="input-row">
              <label><FormattedMessage id="CreateDomainLabel.securityCode" /></label>
              <div>
                <CardCvcElement
                  onChange={this.handleChangeToken}
                  {...createOptions()}
                />
              </div>
            </div>
          </div>
        </div>
        <div>
            <input type="checkbox" required checked={this.state.checked} onChange={this.onChangeAction} errorText="here" />&nbsp;&nbsp;<a href="https://www.freshvoice.net/lfv/agreement.html" target="_blank" style={{ color: '#5a5a5a' }}><FormattedMessage id="CreateDomainLabel.iAgreeText" /></a>
            <br />
            {!this.state.checked ?<span style={{ fontSize: '12px',lineHeight: '12px', color:'#DC3545'}}>  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;<FormattedMessage id='login.requiredField' /></span> : ''}
        </div>
        <button type="submit" className="btn"><FormattedMessage id="CreateDomainLabel.proceedToConfirm" /> </button>
        <div className="text-center bottom-text-bg">
          <p>
            <a href="https://www.freshvoice.net/lfv/index.html" target="_blank" style={{ color: '#5a5a5a' }}><FormattedMessage id="CreateDomainLabel.payByInvoiceText" /></a>
          </p>
          <p>
            <a href="https://www.freshvoice.net/lfv/info.html" target="_blank" style={{ color: '#5a5a5a' }}><FormattedMessage id="CreateDomainLabel.transactionLawText" /></a>
          </p>
        </div>
      </form>
    );
  }
}

export default injectStripe(StripePaymentForm)



// WEBPACK FOOTER //
// src/routes/ManagePlans/Plans/StripePaymentForm.js